import type { FunctionComponent } from 'react';
import { useSchoolPageBySlugQuery } from '../../../../graphql/useSchoolPageBySlugQuery';
import { BreadCrumbsBar } from '../../../../../app-kit/components/BreadCrumbs/BreadCrumbs';

export const SchoolPageBreadCrumbsWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugQuery();

  const breadCrumbs = data?.schoolPageBySlug?.breadCrumbs;
  if (!breadCrumbs) return null;

  return <BreadCrumbsBar crumbs={breadCrumbs} />;
};
